export const TASK_ACTION_CREATE = "create";
export const TASK_ACTION_VIEW = "view";
export const TASK_ACTION_APPLY = "apply";
export const TASK_ACTION_ACCEPT = "accept";
export const TASK_ACTION_DELIVERED = "Delivered";
export const TASK_ACTION_SEND = "send";
